import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import colors from 'vuetify/util/colors'
//import '@mdi/font/css/materialdesignicons.css'
//import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { md } from 'vuetify/iconsets/md'

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
      md,
    },
  },  
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#e30613',
          //primary: colors.red.lighten2,
          //primary: colors.blue.darken2,
          secondary: colors.grey.darken1,
          accent: colors.shades.black,
          error: colors.purple.accent4
          //error: colors.red.accent3
        }
      },
      dark: {
        colors: {
          primary: colors.blue.lighten3
        }
      }
    }
  }  
});
